import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["container"];

  show(message) {
    //トーストメッセージを構築
    const messageText = Object.assign(document.createElement("p"), {
      className: "toast-message__text",
      textContent: message,
    });
    const messageInner = Object.assign(document.createElement("div"), {
      className: "toast-message__inner",
    });
    messageInner.appendChild(messageText);

    const closeButton = Object.assign(document.createElement("button"), {
      className: "toast-message__close",
      textContent: "通知を閉じる",
    });
    closeButton.setAttribute("data-action", "toast#close");

    const messageBase = Object.assign(document.createElement("div"), {
      className: "toast-message",
    });
    messageBase.setAttribute("aria-live", "polite");
    messageBase.appendChild(messageInner);
    messageBase.appendChild(closeButton);

    const toast = Object.assign(document.createElement("div"), {
      className: "toast",
    });
    toast.setAttribute("data-controller", "toast");
    toast.appendChild(messageBase);

    const parent = this.#parent();
    // ドロワー内のトーストは、画面中央に表示されるドロワーに合わせて位置を調整する（custom.css）
    if (parent !== this.containerTarget) toast.classList.add("toast--in-drawer");
    parent.appendChild(toast);
  }

  // モーダルとして開いている dialog はトップレイヤーに描画され、外側の要素より手前に出せないため、
  // 表示中のドロワーがある場合はその dialog 直下に追加する。
  // （.drawer__inner は transform と overflow: hidden を持ち、fixed 配置が崩れるため、その中には追加しない）
  // 閉じる途中のモーダルは is-open が外れているため対象外とする。
  #parent() {
    const openDialogs = document.querySelectorAll("dialog.js-drawer[open].is-open");
    return openDialogs.length > 0 ? openDialogs[openDialogs.length - 1] : this.containerTarget;
  }
}
